export enum CALLER {
    shell = "shell",
    map = "map",
    mapOutline = "map.outline",
    mapNotepad = "map.notepad",
    pdf = "pdf",
    editor = "editor",
    math = "math",
    claire = "claire"
}
